module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-3.ac9d6884.jpg";